import React from 'react';

import { TextField } from '@material-ui/core';

const Render = (props) => {

    const { actions, portfolio } = props;

    return <div style={{ width: '100%' }}>
        <div style={{ display: 'flex' }}>
            <div style={{ marginTop: 25, fontWeight: 'bold', marginRight: 20 }}>Portfolio Name</div>
            <div>
                <TextField
                    margin="normal"
                    variant="outlined"
                    style={{ width: 300 }}
                    value={portfolio.name ? portfolio.name : ''}
                    onChange={(event) => {
                        actions.setPortfolioValue(props, portfolio.portfolioNumber, "name", event.target.value);
                    }}
                    inputProps={{
                        style: {
                            padding: 10,
                        }
                    }}
                />
            </div>
        </div>
    </div>
};

function isComplete(props) {

    const { portfolio } = props;

    return !!portfolio.name;
}

const Description = (props) => {
    return <div>
        <p>
            Enter a name for your portfolio. This does not need to be the actual name of the portfolio, this will help you locate it in the future.
        </p>
    </div>
}

export { Render, isComplete, Description };


// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/PortfolioName.js